import React, { memo } from 'react'

import RichText from '../text/RichText'
// import ShowMoreText from './ShowMoreText'
// import customConfig from 'customConfig'
import Text from '../text/Text'

const NftDescription = ({ content }) => {
  return (
    <Text
      variant='body2'
      sx={{ color: 'text.secondary' }}
      component='div'
      label={<RichText content={content} />}
    />
  )
  // return (
  //   <Scrollbar sx={{ maxHeight: 200, width: '100%' }}>
  //     {customConfig.disableToggleMoreNftDetails ? (
  //       <RichText content={content} />
  //     ) : (
  //       <ShowMoreText t={t} content={content} />
  //     )}
  //   </Scrollbar>
  // )
}

export default memo(NftDescription)
